import { z } from 'zod';

export const ZipCode = z
  .string()
  .regex(/^\d{5}/, 'Invalid zip code format.')
  .min(5, 'Zip Code must have 5 digits.')
  .max(5, 'Zip Code must have 5 digits.');

// eslint-disable-next-line no-redeclare
export type ZipCode = z.infer<typeof ZipCode>;
